import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import apiFetchBalanceOnHandThresholdsEdit from '../../api/BalanceOnHandThresholdsEditAPI';
import { BOH_THRESHOLDS_EDIT_REQUEST } from '../actions/types/BalanceOnHandThresholdsEditActionsTypes';
import { postBalanceOnHandThresholdsEditSuccessActionCreator, postBalanceOnHandThresholdsEditFailureActionCreator } from '../actions/BalanceOnHandThresholdsEditActions';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';

function* doBalanceOnHandThresholdEditWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchBalanceOnHandThresholdsEdit, action.payload);
    yield put(postBalanceOnHandThresholdsEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: <FormattedMessage
        id="notification.threshold.modification.transaction.create.success"
        values={{ transactionProcessingFrequency: process.env.transactionProcessingFrequency }}
      />,
    }));
  } catch (error) {
    yield put(postBalanceOnHandThresholdsEditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.bohthresholds.edit.failure'),
    }));
  }
}

function* doBalanceOnHandThresholdEditWatcher() {
  yield takeLatest(BOH_THRESHOLDS_EDIT_REQUEST, doBalanceOnHandThresholdEditWorker);
}

export default doBalanceOnHandThresholdEditWatcher;
